<section class="dialog-container">
    <h1 mat-dialog-title class="text-center">
        Nuova versione disponibile</h1>
    <br>
    <div mat-dialog-content>
        <p class="f-s-16">È disponibile una nuova versione dell'applicazione.<br>Vuoi aggiornare ora?</p>
    </div>

    <div mat-dialog-actions style="display: flex; justify-content: flex-end; gap: 8px; margin-top: 24px;">
        <button mat-raised-button color="primary" (click)="update()">Aggiorna ora</button>
    </div>
</section>